var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import Common from './module/common.vue';
import { getVisionAuthMessage } from '@/common/api/version';
import VersionAuthCountDownModal from '@/layout/components/Header/VersionAuthCountDownModal.vue';
import VersionAuthHintModal from '@/layout/components/Header/VersionAuthHintModal.vue';
import eventLib from '@/common/utils/document-event';
import { getStorage, setStorage } from '@lhb/cache';
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.authCountDownVisible = false; // 版本授权倒计时提醒
        _this.authHintVisible = false; // 版本授权时间范围提醒
        _this.versionData = {}; // 版本信息
        return _this;
    }
    /* hooks */
    Layout.prototype.created = function () {
        var _this = this;
        var _a, _b;
        // 页面加载时读取localStorage的状态信息
        var store = getStorage('store');
        if (store && store.common && Object.keys(store.common).length && Object.keys(store.app).length && Object.keys(store.crm).length && Object.keys(store.permission).length) {
            this.$store.replaceState(Object.assign({}, this.$store.state, getStorage('store')));
        }
        var user = (_b = (_a = this.$store.state) === null || _a === void 0 ? void 0 : _a.common) === null || _b === void 0 ? void 0 : _b.user;
        if (user && user.id) {
            this.$store.dispatch('$_UpdateUserInfo');
            this.$store.dispatch('$_UpdateCompanyList');
            this.$store.dispatch('$_UpdatePermission');
            this.$store.dispatch('getAuth');
        }
        window.$_EventLib.on('navigate', function (path) {
            _this.$router.push(path);
            window.scrollTo(0, 0);
        });
        this.getVisionAuthMessageModal();
        eventLib.on('LOADING', function () {
            _this.getVisionAuthMessageModal();
        });
    };
    Layout.prototype.mounted = function () {
        var _this = this;
        document.addEventListener('visibilitychange', function () {
            // 切离该页面时将vuex的信息保存到localStorage中
            if (document.visibilityState === 'hidden') {
                setStorage('store', _this.$store.state);
                setStorage('hasOtherLogin', '0'); // 刷新时重置409弹窗状态，参见 common/request/utils.ts line 128 case: 409
            }
            else if (document.visibilityState === 'visible') {
                /**
                 * 切换到该页面时判断是否在其它窗口执行了登录或退出登录操作
                 * 若执行了登录操作将本窗口页面跳转到选择项目页
                 * 若执行了退出操作将本窗口返回到登录页
                */
                var store = getStorage('store');
                var common = (store === null || store === void 0 ? void 0 : store.common) || null;
                var user = _this.$store.state && _this.$store.state.common && _this.$store.state.common.user ? _this.$store.state.common.user : null;
                if (common && common.user) {
                    _this.$store.replaceState(Object.assign({}, _this.$store.state, getStorage('store')));
                    if (!user || user.id !== common.user.id) {
                        var returnMenu = ['/organize']; // saasadmin后台配置空菜单权限，但是还会默认返回organize菜单权限，应该是那边的bug，这里暂时先过滤掉，防止404
                        var menuList = _this.$store.state.common.menuList || [];
                        var path = menuList.length ? menuList[0].children.length ? menuList[0].children[0].uri : menuList[0].uri : '/schedule';
                        _this.$router.replace({ path: returnMenu.includes(path) ? '/schedule' : path });
                    }
                }
                else {
                    var paths = ['/login', '/login/retrieve-password', '/schedule/static', '/agreement/privacy', '/agreement/appPrivacy', '/lhb-micro-pms/ppt'];
                    if (paths.indexOf(_this.$route.path) < 0) {
                        window.$_EventLib.dispatch('LOGOUT', null);
                    }
                }
            }
        });
        // 在页面刷新或关闭时将vuex的信息保存到localStorage中
        // window.addEventListener('beforeunload', () => {
        //   setStorage('store', this.$store.state);
        //   setStorage('hasOtherLogin', '0'); // 刷新时重置状态
        // });
        // // 在浏览器窗口失焦时保存到localStorage中
        // window.addEventListener('blur', () => {
        //   setStorage('store', this.$store.state);
        // });
        // 在浏览器窗口聚焦时读取localStorage的状态信息
        // window.addEventListener('focus', () => {
        //   this.$store.replaceState(Object.assign({}, this.$store.state, getStorage('store')));
        // });
    };
    /** method */
    /**
     * 获取版本信息
     */
    Layout.prototype.getVisionAuthMessageModal = function () {
        var _this = this;
        getVisionAuthMessage().then(function (res) {
            _this.versionData = res;
            // res.type = Math.round(Math.random()) + 1; // 随机type，为了显示弹出框
            if (res.type === 1) { // 开通提醒
                _this.authHintVisible = true;
            }
            else if (res.type === 2) { // 到期提醒
                _this.authCountDownVisible = true;
            }
        });
    };
    Layout = __decorate([
        Component({
            components: {
                Common: Common,
                VersionAuthCountDownModal: VersionAuthCountDownModal,
                VersionAuthHintModal: VersionAuthHintModal,
            },
        })
    ], Layout);
    return Layout;
}(Vue));
export default Layout;
